module.exports = __webpack_public_path__ + "static/img/bystage_04.3316d245.svg";